import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.505 5.21a.714.714 0 0 0-1.01 0L7.209 9.494a.714.714 0 0 0 1.01 1.01L12 6.725l3.78 3.78a.714.714 0 0 0 1.01-1.01zM7.21 14.22l4.286 4.285a.714.714 0 0 0 1.01 0l4.286-4.286a.714.714 0 0 0-1.01-1.01L12 16.99l-3.78-3.78a.714.714 0 0 0-1.01 1.01",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }